import { useItemAction } from '../hooks/useCheckoutAction'
import { ActionProgress, Icon } from '@ztechapps/webui.util'
import { OrderCheckoutActivePanelEnum } from '@ztechapps/order.common'
import React from 'react'

export const ItemActionProgressStep = () => {
  const [onClickItem] = useItemAction()

  return (
    <ActionProgress.Step stepKey={OrderCheckoutActivePanelEnum.item} onClick={onClickItem}>
      <Icon name="magnifying-glass" /> Preview
    </ActionProgress.Step>
  )
}
